import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Container, Tabs, Tab, Accordion, Card, useAccordionButton } from "react-bootstrap";
import { fetchFaqData } from "./Slice/faqSlice";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { getSubdomainPath } from "../../utils/helpers";

function CustomToggle({ children, eventKey, handleClick }) {
  // useAccordionButton returns a function to handle click
  const decoratedOnClick = useAccordionButton(eventKey, () => {
    if (handleClick) handleClick();
  });

  return (
    <button
      type="button"
      onClick={decoratedOnClick}
      className="custom-accordion-toggle"
    >
      {children}
    </button>
  );
}

CustomToggle.propTypes = {
  children: PropTypes.node.isRequired,
  eventKey: PropTypes.string.isRequired,
  handleClick: PropTypes.func,
};

const Index = (props) => {
  const dispatch = useDispatch();
  const history = useNavigate();
  const location = useLocation();
  const { title } = props;

  const { faqData } = useSelector((state) => state?.faq);
  const setting = useSelector((state) => state.setting);

  const [keyword, setKeyword] = useState("");
  const params = new URLSearchParams(location.search);
  const [activeKey, setActiveKey] = useState(0);
  const searchKeyword = params.get("keyword");

  const siteName = setting?.name?.trim() || "Frequently Asked Questions";
  const subDomainPath = getSubdomainPath();
  useEffect(() => {
    const title = `${siteName} - Frequently Asked Questions`;
    document.title = title;

    const fetchData = () => {
      dispatch(fetchFaqData(searchKeyword ? { keyword: searchKeyword } : {}));
      window.scrollTo(0, 0);
      document
        .querySelector('meta[name="description"]')
        .setAttribute(
          "content",
          "Want to know more about our unique mentoring platform? Read the frequently asked questions and reach out to us."
        );
    };
    fetchData();
  }, [siteName, dispatch, title]);

  const handleClickSearch = (e) => {
    e.preventDefault()
    params.set("keyword", keyword);
    history({
      pathname: "/faq",
      search: "?" + params,
    });
    dispatch(fetchFaqData({ keyword: keyword }));
  };

  const prepareHtml = (description) => {
    return { __html: description || "" };
  };

  const resetPage = () => {
    setKeyword("");
    history(`/faq`);
    dispatch(fetchFaqData());
  };

  return (
    <div>
      <section className="outer_main faq_page_main">
        <Container className="">
          <div className="faq_page">
            <div className="help_form_head">
              <h1>How can we help</h1>
              <div className="help_search">
                <form>
                  <button className="btn" type='submit' onClick={(e) => handleClickSearch(e)}>
                    <i className="fas fa-search"></i>
                  </button>
                  <input
                    type="text"
                    value={keyword}
                    className="form-control"
                    placeholder="Search by question..."
                    onChange={(event) => {
                      setKeyword(event.target.value);
                    }}
                  />
                </form>
              </div>
            </div>
            {params.get('keyword') ? (
              <div className="faq-tabs">
                <Accordion defaultActiveKey="1">
                  <p> Search by <strong>"{params.get('keyword')}"</strong>&nbsp;&nbsp;
                    <button onClick={resetPage} className="link ms-auto" style={{ all: "unset", cursor: "pointer" }}>
                      Reset Filters
                    </button>
                  </p>
                  {faqData && faqData.length > 0 &&
                    faqData.map((item, key) => (
                      <div key={item.id}>
                        <div className="faq_tabs_main">
                          <CustomToggle
                            as={Card.Header}
                            eventKey={key + 1}
                            handleClick={() => {
                              if (activeKey === key + 1) {
                                setActiveKey(null);
                              } else {
                                setActiveKey(key + 1);
                              }
                            }}
                          >
                            {item.title}
                            {activeKey === key + 1 ? <span className='collapse_toggle_inner'><i className="fas fa-minus"></i></span> : <span className='collapse_toggle_inner'><i className="fas fa-plus"></i></span>}
                          </CustomToggle>
                          <Accordion.Collapse eventKey={key + 1}>
                            <Card.Body>
                              <div className="faq-description"
                                dangerouslySetInnerHTML={prepareHtml(
                                  item.description
                                )}
                              ></div>
                            </Card.Body>
                          </Accordion.Collapse>
                        </div>
                      </div>
                    ))}
                </Accordion>
                {faqData.length === 0 && (
                  <div className="text-center">No data found.</div>
                )}
              </div>
            ) : (
              <Tabs
                defaultActiveKey="generalqueries"
                id="uncontrolled-tab-example"
              >
                {/* General-Queries */}
                <Tab eventKey="generalqueries" title={['siduat', 'sid', 'siddev'].includes(subDomainPath) ? "General FAQs" : "General Q&A"}>
                  <div className="faq-tabs">
                    <Accordion defaultActiveKey="1">
                      <h2 className="title">{['siduat', 'sid', 'siddev'].includes(subDomainPath) ? "General FAQs" : "General Q&A"}</h2>
                      {faqData && faqData.length > 0 &&
                        faqData.map((item, key) => (
                          <div key={item.id}>
                            {item.type === 'General Queries' && (
                              <div className="faq_tabs_main">
                                <CustomToggle
                                  as={Card.Header}
                                  eventKey={key + 1}
                                  handleClick={() => {
                                    if (activeKey === key + 1) {
                                      setActiveKey(null);
                                    } else {
                                      setActiveKey(key + 1);
                                    }
                                  }}
                                >
                                  {item.title}
                                  {activeKey === key + 1 ? <span className='collapse_toggle_inner'><i className="fas fa-minus"></i></span> : <span className='collapse_toggle_inner'><i className="fas fa-plus"></i></span>}
                                </CustomToggle>

                                <Accordion.Collapse eventKey={key + 1}>
                                  <Card.Body>
                                    <div className="faq-description"
                                      dangerouslySetInnerHTML={prepareHtml(
                                        item.description
                                      )}
                                    ></div>
                                  </Card.Body>
                                </Accordion.Collapse>
                              </div>
                            )}
                          </div>
                        ))}
                    </Accordion>
                  </div>
                </Tab>

                {/* Mentor Queries */}
                <Tab eventKey="mentorqueries" title={['siduat', 'sid', 'siddev'].includes(subDomainPath) ? "Mentor FAQs" : "Mentor Q&A"}>
                  <div className="faq-tabs">
                    <Accordion defaultActiveKey="0">
                      <h2 className="title">{['siduat', 'sid', 'siddev'].includes(subDomainPath) ? "Mentor FAQs" : "Mentor Q&A"}</h2>
                      {faqData && faqData.length > 0 &&
                        faqData.map((item, key) => (
                          <div key={item.id}>
                            {item.type === 'Mentor Queries' && (
                              <div className="faq_tabs_main">
                                <CustomToggle
                                  as={Card.Header}
                                  eventKey={key + 1}
                                  handleClick={() => {
                                    if (activeKey === key + 1) {
                                      setActiveKey(null);
                                    } else {
                                      setActiveKey(key + 1);
                                    }
                                  }}
                                >
                                  {item.title}
                                  {activeKey === key + 1 ? <span className='collapse_toggle_inner'><i className="fas fa-minus"></i></span> : <span className='collapse_toggle_inner'><i className="fas fa-plus"></i></span>}
                                </CustomToggle>
                                <Accordion.Collapse eventKey={key + 1}>
                                  <Card.Body>
                                    <div className="faq-description"
                                      dangerouslySetInnerHTML={prepareHtml(
                                        item.description
                                      )}
                                    ></div>
                                  </Card.Body>
                                </Accordion.Collapse>
                              </div>
                            )}
                          </div>
                        ))}
                    </Accordion>
                  </div>
                </Tab>

                {/* Mentee Queries */}
                <Tab eventKey="menteequeries" title={['siduat', 'sid', 'siddev'].includes(subDomainPath) ? "Mentee FAQs" : "Mentee Q&A"}>
                  <div className="faq-tabs">
                    <Accordion defaultActiveKey="0">
                      <h2 className="title">{['siduat', 'sid', 'siddev'].includes(subDomainPath) ? "Mentee FAQs" : "Mentee Q&A"}</h2>
                      {faqData &&
                        faqData.length > 0 &&
                        faqData.map((item, key) => (
                          <div key={item.id}>
                            {item.type === 'Mentee Queries' && (
                              <div className="faq_tabs_main">
                                <CustomToggle
                                  as={Card.Header}
                                  eventKey={key + 1}
                                  handleClick={() => {
                                    if (activeKey === key + 1) {
                                      setActiveKey(null);
                                    } else {
                                      setActiveKey(key + 1);
                                    }
                                  }}
                                >
                                  {item.title}
                                  {activeKey === key + 1 ? <span className='collapse_toggle_inner'><i className="fas fa-minus"></i></span> : <span className='collapse_toggle_inner'><i className="fas fa-plus"></i></span>}
                                </CustomToggle>

                                <Accordion.Collapse eventKey={key + 1}>
                                  <Card.Body>
                                    <div className="faq-description"
                                      dangerouslySetInnerHTML={prepareHtml(
                                        item.description
                                      )}
                                    ></div>
                                  </Card.Body>
                                </Accordion.Collapse>
                              </div>
                            )}
                          </div>
                        ))}
                    </Accordion>
                  </div>
                </Tab>
              </Tabs>
            )}
          </div>
        </Container>
      </section>
    </div>
  );
};

Index.propTypes = {
  title: PropTypes.string.isRequired,
};

export default Index;
